<template>
  <section class="pt-0 pb-10 px-10 lg:px-32">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
      
      <!-- Left Side: About Us Text Content -->
      <div class="space-y-6 text-center lg:text-left" data-aos="fade-right">
        <h1 class="text-4xl lg:text-7xl font-bold text-[#E3A13F] uppercase drop-shadow-[2px_2px_5px_rgba(227,161,63,0.7)]">
          About Us
        </h1>

        <hr class="border-[#E3A13F] w-32 mx-auto lg:mx-0">
        <p class="text-lg leading-relaxed font-quicksand">
          From humble beginnings, Revest360 came to be from learning about responsibility, 
          self-reliance, saving, budgeting, and protecting your assets. Further understanding financial 
          concepts such as investing and the power of compound interest. This was the lifestyle that 
          eventually led CEO <strong>Michael H. Collins</strong> to end up at Georgia Tech, and then to a job in 
          corporate America that has allowed him to now come full circle to Revest360 and the <strong>Circle of Prosperity</strong>.
        </p>
      </div>

      <!-- Right Side: About Us Image -->
      <div class="relative flex justify-center" data-aos="fade-left">
        <img 
          loading="lazy"
          src="../assets/images/about.webp" 
          alt="Revest360 team working on financial literacy" 
          class="w-full max-w-md lg:max-w-full" 
          width="600" 
          height="400" 
          style="object-fit: cover;"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { useAos } from '../hooks/useAos';

useAos();
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600;700&display=swap');

.font-quicksand {
  font-family: 'Quicksand', sans-serif;
}
</style>
